import { Pipe } from "@angular/core";
import { parsePhoneNumber } from "libphonenumber-js";

@Pipe({
  name: 'phone'
})
export class PhonePipe {
  transform(rawValue: string) {
    try {
      let phoneNumber = parsePhoneNumber(rawValue);
      if (phoneNumber === undefined) {
        phoneNumber = parsePhoneNumber(rawValue, 'FR')
      }
      if (phoneNumber === undefined) {
        return rawValue;
      }
      return phoneNumber.formatInternational()
    } catch {
      return rawValue;
    }
  }
}
